export default "__VITE_ASSET__a82642e9__"